export const downloadCsvFromJson = async (json: any[], csvName: string) => {
  const csvString = convertJsonToCsvString(json);
  const htmlAnchorElement = createDownloadAnchorElement(csvString, csvName);
  downloadCsv(htmlAnchorElement);
};

export const convertJsonToCsvString = (items: any[]) => {
  const header = Object.keys(items[0]);
  const headerString = header.join(",");

  const replacer = (_key: string, value: string) => value ?? "";
  const rowItems = items.map((row) =>
    header
      .map((fieldName) => JSON.stringify(row[fieldName], replacer))
      .join(",")
  );

  const csv = [headerString, ...rowItems].join("\r\n");
  return csv;
};

export const createDownloadAnchorElement = (
  csvString: string,
  csvName: string
) => {
  const url = URL.createObjectURL(new Blob([csvString]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${csvName}.csv`);
  return link;
};

const downloadCsv = (anchorElement: HTMLAnchorElement) => {
  document.body.appendChild(anchorElement);
  anchorElement.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );
  document.body.removeChild(anchorElement);
};
